import { render, staticRenderFns } from "./chat-context.vue?vue&type=template&id=1ede7e3b&scoped=true&"
import script from "./chat-context.vue?vue&type=script&lang=js&"
export * from "./chat-context.vue?vue&type=script&lang=js&"
import style0 from "./chat-context.vue?vue&type=style&index=0&id=1ede7e3b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ede7e3b",
  null
  
)

export default component.exports